<template>
  <SeoPillarLandingPage :content="$t('seoPillarPaginaDeVendas')" faq-src="/seo-faq/pagina-de-vendas-para-afiliados.json"/>
</template>
<script>
import SeoPillarLandingPage from "../fragments/SeoPillarLandingPage.vue";
export default {
  name: 'PillarPaginaDeVendasParaAfiliados',
  components: { SeoPillarLandingPage },
}
</script>
